import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import Skeleton from 'react-loading-skeleton';

import DataTable from '../../components/Datatable/DataTable';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import { filterErrorHandler } from '../../hoc/Shared/utility';
import Button from '../../components/Button/Button';

import * as actions from '../../store/ducks/agentPayout/actions';

class AgentDeductDetails extends Component {
    constructor(props) {
        super(props);
        this.state =
        {
            activePage: 1,
            limit: 10,
            totalRecords: 0,
            searchValue: '',
            order: '',

            data: [],
            agentDetails: [],
            loading: true,
            loadOnce: true,
        };
    }

    /* ============ component lifecycle [START] ============ */
    componentDidMount() {
        const listingArr = this.getFilterArray();
        this.props.funcGetDeductDetails(listingArr);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.deductDetails !== this.props.deductDetails && nextProps.deductDetails !== undefined) {
            if (nextProps.deductDetails.responseCode === 200 && nextProps.deductDetails.msgType === 'success') {
                this.setState({
                    agentDetails: nextProps.deductDetails.data.agent,
                    data: nextProps.deductDetails.data.result.row,
                    totalRecords: nextProps.deductDetails.data.result.pagination.total_record,
                    loading: false,
                    loadOnce: false,
                });
            }
            else {
                this.setState({
                    agentDetails: [],
                    data: [],
                    totalRecords: 0,
                    activePage: 1,
                    loading: false,
                    loadOnce: false
                }, () => {
                    filterErrorHandler(nextProps.deductDetails.message);
                });
            }
            Swal.close();
        }
        return true;
    }
    /* ============ component lifecycle [END] ============ */

    /* ============ function [START] ============ */
    refreshHandler = () => {
        const listingArr = this.getFilterArray();
        this.props.funcGetDeductDetails(listingArr);
    }

    getFilterArray = () => {
        const listingArr = {};
        const param = this.props.deductDetailsParam;

        listingArr.page = this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.aid = param.aid;
        listingArr.date = param.date;

        this.setState({
            loading: true,
            data: [],
        });
        return listingArr;
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = ((this.state.activePage - 1) * this.state.limit) + (rowIndex + 1);
        return <span>{rowNumber}</span>;
    }
    /* ============ function [END] ============ */

    /* ============ datatables function [START] ============ */
    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === 'asc') ? true : false;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({ order: orderArry }, () => {
            this.refreshHandler();
        });
    }

    datatablesChangeHandler = (val, act) => {
        this.setState({
            [act]: (act === 'searchValue') ? val.target.value : val
        }, () => {
            this.refreshHandler();
        });
    }
    /* ============ datatables function [END] ============ */

    render() {
        const { t } = this.props;
        let display = null;
        const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

        if (this.state.agentDetails) {
            const columns =
                [
                    {
                        text: t('global.no'),
                        dataField: 'no',
                        formatter: (cell, row, rowIndex) => {
                            let rowNumber = ((this.state.activePage - 1) * this.state.limit) + (rowIndex + 1);
                            return <span>{rowNumber}</span>;
                        },
                        headerStyle: { width: '60px', textAlign: 'center' }
                    },
                    {
                        text: 'ID',
                        dataField: 'id',
                        sort: true,
                        onSort: this.onSort,
                        headerStyle: { width: '80px' }
                    },
                    {
                        text: t('agent-payout.member'),
                        dataField: 'member',
                        sort: true,
                        onSort: this.onSort,
                    },
                    {
                        text: t('transaction.order-id'),
                        dataField: 'order_id',
                        sort: true,
                        onSort: this.onSort,
                    },
                    {
                        text: t('transaction.transaction-type'),
                        dataField: 'title',
                        sort: true,
                        onSort: this.onSort,
                    },
                    {
                        text: `${t('transaction.debit')} (${t('global.currency.usd')})`,
                        dataField: 'debit_usd',
                        formatter: (cell, row, rowIndex) => {
                            const usdValue = new Intl.NumberFormat('en-US', { maximumFractionDigits: 3, minimumFractionDigits: 2 }).format(row.debit_usd);
                            const baseValue = new Intl.NumberFormat('en-US', num_format).format(row.debit);
                            const rate = row.exchange_rate;
                            
                            return (
                                <div>
                                    <b>{usdValue}</b><br />
                                    <small>({baseValue}/{rate})</small>
                                </div>
                            );
                        },
                        sort: true,
                        onSort: this.onSort,
                    },
                    {
                        text: `${t('transaction.credit')} (${t('global.currency.usd')})`,
                        dataField: 'credit_usd',
                        formatter: (cell, row, rowIndex) => {
                            const usdValue = new Intl.NumberFormat('en-US', { maximumFractionDigits: 3, minimumFractionDigits: 2 }).format(row.credit_usd);
                            const baseValue = new Intl.NumberFormat('en-US', num_format).format(row.credit);
                            const rate = row.exchange_rate;
                            
                            return (
                                <div>
                                    <b>{usdValue}</b><br />
                                    <small>({baseValue}/{rate})</small>
                                </div>
                            );
                        },
                        sort: true,
                        onSort: this.onSort,
                    },
                    {
                        text: `${t('transaction.fees')} (${t('global.currency.usd')})`,
                        dataField: 'fees_usd',
                        formatter: (cell, row, rowIndex) => {
                            const usdValue = new Intl.NumberFormat('en-US', { maximumFractionDigits: 6, minimumFractionDigits: 2 }).format(row.fees_usd);
                            const baseValue = new Intl.NumberFormat('en-US', { maximumFractionDigits: 6, minimumFractionDigits: 2 }).format(row.fees);
                            const rate = row.exchange_rate;
                            
                            return (
                                <div>
                                    <b>{usdValue}</b><br />
                                    <small>({baseValue}/{rate})</small>
                                </div>
                            );
                        },
                        sort: true,
                        onSort: this.onSort,
                    },
                    {
                        text: t('transaction.create-date'),
                        dataField: 'create_date',
                        sort: true,
                        onSort: this.onSort,
                    },
                ];

            display =
                <Auxiliary>
                    <div className='breadcrumb-header'>
                        <div className='d-flex'>
                            <Button typeButton='button' classValue='btn btn-back-outline' idValue='back' buttonName={<i className="angle fe fe-chevron-left"></i>} clicked={() => this.props.changePageHandler(this.props.deductDetailsParam.returnPage)} />
                            <div className='my-auto'>
                                <div className='member-name'>
                                    <FontAwesomeIcon icon={faUser} /> {this.state.agentDetails.agent}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row row-sm'>
                        <div className='col-lg-12 col-xl-12 col-md-12 col-sm-12'>
                            <div className='card box-shadow-0'>
                                <div className='card-header'>
                                    <h4 className='card-title mg-b-0'>{t('agent-payout.agent-details')}</h4>
                                </div>
                                <div className="card-body pt-0">
                                    {(this.state.loading && this.state.loadOnce)
                                        ?
                                        <Skeleton count={3} />
                                        :
                                        <table className='table table-bordered table-hover'>
                                            <tbody>
                                                <tr>
                                                    <th>{t('agent-payout.date')}</th>
                                                    <td>{this.props.deductDetailsParam.date}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t('agent-payout.agent')}</th>
                                                    <td>{this.state.agentDetails.agent}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t('agent-payout.base-currency')}</th>
                                                    <td>{this.state.agentDetails.currency}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    }
                                    {this.state.loading
                                        ?
                                        <Skeleton count={1} />
                                        :
                                        <div className="mb-0 mt-3 justify-content-end d-flex my-xl-auto right-content">
                                            <Button typeButton='button' classValue='btn btn-blue' idValue='refresh' buttonName={t('global.refresh')} clicked={() => this.refreshHandler()} />
                                        </div>
                                    }
                                </div>
                            </div>


                            <div className='card box-shadow-0'>
                                <div className='card-header'>
                                    <div className='card-title mb-1'>
                                        <h4 className='card-title mg-b-0'>{t('transaction.transaction-history')}</h4>
                                        <br/>
                                        <small style={{ color: '#8B0000' }}>
                                            <b>*Showing all transactions that contribute to agent deductions</b>
                                        </small>
                                    </div>
                                </div>

                                <div className='card-body'>
                                    <div className='table-responsive table-hover datatable'>
                                        <DataTable
                                            keyField='id'
                                            data={this.state.data}
                                            columns={columns}
                                            activePage={this.state.activePage}
                                            limit={this.state.limit}
                                            totalItems={this.state.totalRecords}
                                            paginationHandler={(val) => this.datatablesChangeHandler(val, 'activePage')}
                                            sizePerPageHandler={(val) => this.datatablesChangeHandler(val, 'limit')}
                                            searchChangeHandler={(val) => this.datatablesChangeHandler(val, 'searchValue')}
                                            searchValue={this.state.searchValue}
                                            classValue='dataTable table-bordered text-justify text-center'
                                            loading={this.state.loading}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Auxiliary>;
        }
        return (
            <Auxiliary>
                {display}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = state => {
    return {
        deductDetails: state.agentPayout.deductDetails,
    }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch => {
    return {
        funcGetDeductDetails: (listingArr) => dispatch(actions.getDeductDetails(listingArr)),
    }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(AgentDeductDetails));

